@if (cannotLoadData) {
  <div class="h-full">
    <app-something-went-wrong
      [showPicture]="false"
      (retryEmitter)="ngOnInit()"></app-something-went-wrong>
  </div>
}

@if (isLoading) {
  <app-skeleton-email></app-skeleton-email>
}

@if (!isLoading && !cannotLoadData) {
  <div
    class="dropzone flex h-full justify-between overflow-y-auto overflow-x-clip"
    tourAnchor="newEmailModal"
    (click)="setCurrentTagsElement()"
    (dragover)="onDragOver($event)">
    <div class="drawer-content-screen w-full">
      <div class="w-full pr-2">
        <form
          class="create-email-form"
          [formGroup]="form"
          autocomplete="off"
          novalidate>
          <div
            class="flex w-full flex-row flex-wrap content-center justify-between">
            <div class="form flex-grow">
              <div class="relative flex">
                <span class="custom-top absolute">{{
                  'from' | translate
                }}</span>
                <div class="subject">{{ senderAddress }}</div>
              </div>
              <div class="relative flex">
                <button
                  mat-icon-button
                  matTooltip="{{ 'openContacts' | translate }}"
                  class="folder-icon"
                  (click)="openContactsDialog()">
                  <mat-icon>folder_shared</mat-icon>
                </button>
                <div
                  [class.show-cc-btn]="!showCc"
                  class="folder-add-cc"
                  (click)="showCc = true">
                  @if (isContactsLoadingTo) {
                    <mat-progress-spinner
                      class="w-[24px]"
                      mode="indeterminate"
                      diameter="16"></mat-progress-spinner>
                  }
                  @if (!showCc) {
                    <div class="cursor-pointer hover:underline">
                      {{ 'addCc' | translate }}
                    </div>
                  }
                </div>
                <div
                  [ngStyle]="{
                    'max-height': currentTagsElement === 1 ? '165px' : '60px',
                  }"
                  id="tags-to"
                  class="tags-main relative flex overflow-auto">
                  <span class="custom-top custom-top_tags absolute">{{
                    'to' | translate
                  }}</span>
                  <app-email-tags
                    class="w-full"
                    [placeHolder]="'to'"
                    [toList]="initToList"
                    [initContacts]="initToContacts"
                    (dynamicSearchValue)="getContactsTo($event)"
                    (changeList)="changeToList($event)"
                    (setCurrentTagsElement)="setCurrentTagsElement(1)"
                    [showCc]="showCc"
                    [existedContacts]="contactsListTo"></app-email-tags>
                </div>
              </div>
            </div>
          </div>
          @if (showCc) {
            <div
              class="flex w-full flex-row flex-wrap content-center justify-between">
              <div class="form flex-grow">
                <button
                  mat-icon-button
                  matTooltip="{{ 'openContacts' | translate }}"
                  class="folder-icon"
                  (click)="openContactsDialog(true)">
                  <mat-icon>folder_shared</mat-icon>
                </button>
                <div
                  [class.show-cc-btn]="!showCc"
                  class="folder-add-cc"
                  (click)="showCc = true">
                  @if (isContactsLoadingCc) {
                    <mat-progress-spinner
                      class="w-[24px]"
                      mode="indeterminate"
                      diameter="16"></mat-progress-spinner>
                  }
                </div>
                <div
                  [ngStyle]="{
                    'max-height': currentTagsElement === 2 ? '165px' : '60px',
                  }"
                  id="tags-cc"
                  class="tags-main relative flex overflow-auto">
                  <span class="custom-top_tags custom-top absolute">{{
                    'cc' | translate
                  }}</span>
                  <app-email-tags
                    class="w-full"
                    [placeHolder]="'cc'"
                    (dynamicSearchValue)="getContactsCc($event)"
                    (changeList)="changeCcList($event)"
                    (setCurrentTagsElement)="setCurrentTagsElement(2)"
                    [toList]="initCcList"
                    [initContacts]="initCcContacts"
                    [existedContacts]="contactsListCc"></app-email-tags>
                </div>
              </div>
            </div>
          }
          <div class="relative flex">
            <span class="custom-top absolute">{{ 'subject' | translate }}</span>
            <input
              matInput
              class="subject"
              type="text"
              formControlName="subject"
              (keydown.enter)="$event.preventDefault()" />
            @if (hasError('subject', 'maxlength')) {
              <mat-error>You have more than 2048 characters</mat-error>
            }
          </div>
          <app-field-tags-list
            [thisTags]="thisTags"
            (openAddTag)="openAddTag()" />
        </form>
      </div>
      <div class="min-h-[200px] flex-grow">
        <div class="drawer-content-screen__body">
          <app-email-body
            [body]="body"
            (valueChangedEventEmitter)="valueChangedEventEmitter($event)"
            class="h-full min-h-[200px]"></app-email-body>
        </div>
      </div>
      <app-email-attachments-list
        [attachmentFiles]="attachmentFiles"
        [emailId]="emailId"
        [isDragging]="isDragging"
        (resetIsDragging)="isDragging = false"
        [disabled]="submitInProgress || saveInProgress || useMobileView"
        (addAttachmentFile)="addAttachmentFile($event)"
        (deleteAttachment)="deleteAttachment($event)" />
      <div class="w-full">
        <div class="flex justify-between overflow-hidden">
          <div class="icon-button-group flex items-center md:hidden">
            <button
              mat-icon-button
              matTooltip="{{
                canSend ? ('send' | translate) : ('readyToValidate' | translate)
              }}"
              (click)="onSubmit(true)"
              [disabled]="!validateForm || !isEveryFileUploaded">
              <mat-icon>send</mat-icon>
            </button>

            <button
              [disabled]="!isEveryFileUploaded"
              mat-icon-button
              matTooltip="{{ 'save' | translate }}"
              (click)="saveAsDraft()">
              <mat-icon>save_outline</mat-icon>
            </button>

            <ng-container
              *ngTemplateOutlet="templatesButtonTemplate"></ng-container>
            <app-notes-button
              (click)="showNotes()"
              [hasCount]="isNotesChanged" />
            <ng-container
              *ngTemplateOutlet="uploadButtonTemplate"></ng-container>
            <app-delete-button (click)="delete()" />
            <ng-container *ngTemplateOutlet="splitSendTemplate"></ng-container>
          </div>

          <div class="hidden md:flex md:items-center md:gap-2">
            <button
              class="page-block-button"
              color="primary"
              mat-flat-button
              (click)="onSubmit(true)"
              [disabled]="
                !validateForm ||
                submitInProgress ||
                saveInProgress ||
                !isEveryFileUploaded
              ">
              <app-loading-button
                text="{{
                  canSend
                    ? ('send' | translate)
                    : ('readyToApprove' | translate)
                }}"
                [loading]="
                  submitInProgress && !saveInProgress
                "></app-loading-button>
            </button>

            <button
              class="page-block-button"
              color="primary"
              mat-flat-button
              (click)="saveAsDraft()"
              [disabled]="
                submitInProgress || saveInProgress || !isEveryFileUploaded
              ">
              <app-loading-button
                text="{{ 'save' | translate }}"
                [loading]="saveInProgress"></app-loading-button>
            </button>
          </div>

          <div class="hidden md:flex md:items-center md:gap-2">
            <ng-container *ngTemplateOutlet="splitSendTemplate"></ng-container>
            <ng-container
              *ngTemplateOutlet="uploadButtonTemplate"></ng-container>
            <ng-container
              *ngTemplateOutlet="templatesButtonTemplate"></ng-container>
            <app-notes-button
              (click)="showNotes()"
              [hasCount]="isNotesChanged" />
            <app-delete-button (click)="delete()" />
            <app-audit-button (click)="audit()" />
            <button
              matTooltip="{{ 'resetAll' | translate }}"
              color="primary"
              mat-icon-button
              (click)="openConfirmDialog('resetSubtitle', 'resetTitle')">
              <mat-icon>restart_alt</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
    <app-email-sidenav
      [menuContent]="menuContent"
      [useMobileView]="useMobileView"
      [emailId]="emailId"
      [mailAccountId]="mailAccountId"
      [menuIsOpened]="menuIsOpened"
      [emailDetails]="email"
      (templateSelected)="templateSelected($event)"
      (refreshNotes)="refreshNotes()"
      (closeMenu)="closeMenu()"
      (createTag)="createTag($event)"></app-email-sidenav>
  </div>
}

<ng-template #uploadButtonTemplate>
  <input
    #uploader
    [hidden]="true"
    type="file"
    multiple
    (change)="addAttachmentFileFromButton($event)" />
  <button
    mat-icon-button
    aria-label="Attach file(s)"
    matTooltip="{{ 'attachFile' | translate }}"
    (click)="uploader.click()">
    <span class="material-symbols-outlined">attach_file_add</span>
  </button>
</ng-template>

<ng-template #templatesButtonTemplate>
  <button
    mat-icon-button
    aria-label="Open templates"
    matTooltip="{{ 'templates' | translate }}"
    (click)="showTemplates()">
    <mat-icon>library_books</mat-icon>
  </button>
</ng-template>

<ng-template #splitSendTemplate>
  <mat-slide-toggle
    [checked]="isSplitEmail"
    (change)="splitEmailToggle()"
    class="mr-3"
    color="primary"
    matTooltip="{{ 'splitSend' | translate }}"></mat-slide-toggle>
</ng-template>
